import { render, staticRenderFns } from "./FormResponsablesEdit.vue?vue&type=template&id=36061ca8"
import script from "./FormResponsablesEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./FormResponsablesEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports